import { apiFetch } from "../utils/api";
import { idToken } from "./authService";

export interface ExtendedInterestPercentageRow {
  id: number;
  company_id: number | null;
  [key: string]: string | number | boolean | null | undefined;
}

export interface ExtendedInterestPercentageMeta {
  total: number;
  page: number;
  perPage: number;
}

export interface ExtendedInterestPercentageFilters {
  search: string;
  companyId: string;
}

export interface CompanySummary {
  id: number;
  code: string;
  name: string;
}

async function token() {
  return await idToken();
}

export async function fetchExtendedInterestPercentages(
  page: number,
  perPage: number,
  filters: ExtendedInterestPercentageFilters
): Promise<{ data: ExtendedInterestPercentageRow[]; meta: ExtendedInterestPercentageMeta }> {
  const t = await token();
  const q = new URLSearchParams({ page: String(page), perPage: String(perPage) });
  if (filters.search) q.set("search", filters.search);
  if (filters.companyId) q.set("companyId", filters.companyId);

  return apiFetch(t, `/api/extended_interest_percentages/admin_index?${q}`);
}

export async function fetchAllCompanies(): Promise<CompanySummary[]> {
  const t = await token();
  const res = await apiFetch(t, `/api/companies/all`);
  return res.items ?? [];
}
